//  获取供应商信息
import request from '@/utils/server'
 export function getSupplierList(query) {
    return request({
      url: '/Supplier/getSupplierList',
      method: 'get',
      params: query
    })
  }
//   新增供应商
export function add(data) {
    return request({
      url: '/Supplier/add',
      method: 'POST',
      data: data
    })
  }
//   修改供应商
export function edit(data) {
    return request({
      url: '/Supplier/edit',
      method: 'POST',
      data: data
    })
  }
// 删除供应商
export function delSupplier(data) {
    return request({
      url: '/Supplier/delSupplier',
      method: 'POST',
      data: data
    })
  }
//   新增资质图片
export function uploadPhoto(data) {
    return request({
      url: '/Supplier/uploadPhoto',
      method: 'POST',
      data: data
    })
  }
  // 请求供应商菜品
  export function getSupplyMaterials(query) {
    return request({
      url: '/Supplier/getSupplyMaterials',
      method: 'get',
      params: query
    })
  }
  // 新增菜品
  export function addSupplyMaterial(data) {
    return request({
      url: '/Supplier/addSupplyMaterial',
      method: 'POST',
      data: data
    })
  }
  // 删除
    export function delSupplyMaterial(data) {
    return request({
      url: '/Supplier/delSupplyMaterial',
      method: 'POST',
      data: data
    })
  }
    // 修改
    export function editSupplyMaterial(data) {
    return request({
      url: '/Supplier/editSupplyMaterial',
      method: 'POST',
      data: data
    })
  }